import { createSlice } from '@reduxjs/toolkit';
import { requestStatusConstants } from 'Integration/integration-util';

const initialState = {
  getCoverageIndicatorData: {
    data: null,
    changingStatus: requestStatusConstants.INITIAL,
    error: null,
  },
};
const getCoverageIndicatorSlice = createSlice({
  name: 'getCoverageIndicatorSlice',
  initialState,
  reducers: {
    getCoverageIndicatorStarted: (state) => {
      state.getCoverageIndicatorData.changingStatus =
        requestStatusConstants.PROGRESS;
    },
    getCoverageIndicatorSuccess: (state, action) => {
      state.getCoverageIndicatorData.data = action.payload.id;
      state.getCoverageIndicatorData.changingStatus =
        requestStatusConstants.SUCCESS;
    },
    getCoverageIndicatorFailed: (state, action) => {
      state.getCoverageIndicatorData.error = action.payload;
      state.getCoverageIndicatorData.changingStatus =
        requestStatusConstants.FAILED;
    },
    resetGetCoverageIndicatorData: (state) => {
      state.getCoverageIndicatorData = initialState.getCoverageIndicatorData;
    },
  },
});

export const {
  getCoverageIndicatorStarted,
  getCoverageIndicatorSuccess,
  getCoverageIndicatorFailed,
  resetGetCoverageIndicatorData,
} = getCoverageIndicatorSlice.actions;

export default getCoverageIndicatorSlice.reducer;
